import styled from 'styled-components';
import { getSpace, getGridSpan, mq } from '../../../stylesheets/tools';

const StyledContentBlocks = styled.section`
  margin: ${getSpace('l')} 0;
  overflow: hidden;

  &::after {
    display: block;
    content: '';
    clear: both;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    scroll-margin-top: 130px;

    ${mq('m')} {
      scroll-margin-top: 100px;
    }
  }

  .contentBlocks__container {
    position: relative;
    margin-top: ${getSpace('l')};
    margin-bottom: ${getSpace('xxxl')};
  }

  .download-container[data-prev-component='copy'] {
    margin-top: ${getSpace('xl')};
  }

  .copy-container[data-next-component='download'] {
    margin-bottom: 0;

    h3 {
      margin-bottom: 0;
    }
  }

  ${mq('m')} {
    /* Clearfix to avoid weird floating behaviour of embeds */
    .copy-container {
      &:after {
        content: '';
        clear: both;
        display: table;
      }
    }

    .quote--wide-container,
    .audio--wide-container {
      &:before {
        content: '';
        clear: both;
        display: table;
      }
    }

    .download-container:nth-of-type(even) .container__wrapper a {
      margin-left: ${getGridSpan(1, 'spread')};
    }

    .download-container[data-prev-component='copy'] {
      margin-top: 0;
    }

    .copy-container[data-next-component='download'] {
      margin-bottom: 0;

      h3 {
        margin-bottom: 0;
      }
    }

    .download-container[data-prev-component='download'],
    .contact-container[data-prev-component='contact'] {
      margin-top: 0;
    }

    .download-container[data-next-component='download'],
    .contact-container[data-next-component='contact'] {
      margin-bottom: 0;
    }

    .copy-container[data-prev-component='infoBox'],
    .copy-container[data-prev-component='quote'],
    .copy-container[data-prev-component='audio'],
    .copy-container[data-prev-component='singleInfographic'],
    .copy-container[data-prev-component='download--vertical'] {
      h3,
      h2 {
        width: ${getGridSpan(10)};
      }
    }

    .copy-container[data-prev-component='quote'] {
      margin-top: 110px;
    }

    .copy-container[data-prev-component='singleInfographic'] {
      padding-top: 50px;
    }

    .optout-container[data-prev-component='copy'],
    .copy-container[data-prev-component='optout'] {
      margin-top: ${getSpace('l')};
    }

    .optout-container[data-next-component='copy'] {
      margin-bottom: ${getSpace('xl')};
    }

    .copy-container[data-next-component='optout'] {
      margin-bottom: ${getSpace('l')};
    }

    .copy-container[data-next-component='fullwidthImage'] {
      margin-bottom: ${getSpace('xs')};

      h2 {
        margin-bottom: 0;
      }
    }

    .fullwidthImage-container[data-prev-component='copy'] {
      margin-top: 0;

      [type='fullwidthImage'] {
        margin-top: 0;
      }
    }

    .singleInfographic-container,
    .infoBox-container,
    .infographic-container,
    .download-container,
    .download--vertical-container,
    .slider-container,
    .quote-container,
    .audio-container {
      z-index: 1;
    }
  }
`;

export default StyledContentBlocks;
